import React, { forwardRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactPlayer from "react-player/youtube";

import { setOpenModalRevisor } from "../../../../store/actions/termos";
import ModalVideo from "../../../../components/ModalVideo";

import S from "./styles";

const ModalVideoRevisor = forwardRef((props, ref) => {
  const termos = useSelector((state) => state.termos);
  const dispatch = useDispatch();

  const handleOk = () => {
    dispatch(setOpenModalRevisor(false));
    window.location = process.env.REACT_APP_REVISOR_URL;
  };

  function handleModalStorage() {
    dispatch(setOpenModalRevisor(false));
    localStorage.setItem("naoExibirVideoRevisor", true);
  }

  return (
    termos.openModalRevisor && (
      <ModalVideo
        onClose={() => dispatch(setOpenModalRevisor(false))}
        onConfirm={handleOk}
        handleModalStorage={() => handleModalStorage()}
        title="Prezado cliente:"
        buttonText="OK"
        MessageInline="Não exibir mais esta mensagem"
        exclusaoParam={false}
        width={800}
        height={600}
      >
        <S.Content>
          <ReactPlayer
            url="https://www.youtube.com/watch?v=6X9d8MLRMPQ"
            controls
            height={400}
            width={600}
          />
        </S.Content>
      </ModalVideo>
    )
  );
});

export default ModalVideoRevisor;
